/* eslint-disable */


/**
 * Create styles for `<ChipSelector />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ChipSelector />` styles
 */
const chipSelectorStyles = ({ theme }) => ({
  chipLabel: {
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    display: `block`,
  },
  chipRoot: {
    maxWidth: 192,
    borderColor: theme.boralcolorspalette.zambezi[600],
    backgroundColor: `#fff`,
    cursor: `pointer`,
    '&:hover': {
      backgroundColor: `${theme.boralcolorspalette.zambezi[600]}`,
      color: `#fff`,
    },
    '&:hover>*': {
      color: `#fff !important`,
    },
  },
  fullWidthItems: {
    maxWidth: `inherit`,
  },
  menuItem: {
    '&:hover': {
      backgroundColor: `#fff`,
    },
  },
  colorZambezi600: {
    color: theme.boralcolorspalette.zambezi[600],
  },
});

export default chipSelectorStyles;
